import { GCStatusType, GCStatusTypeOptions } from '@apply/constants';

export interface StatusIndicatorProps {
    status: GCStatusType | undefined;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
    const statusOption = GCStatusTypeOptions.find((o) => o.id === status);
    const statusLabel = statusOption?.name;
    const statusEnumName = status !== undefined ? GCStatusType[status] : undefined;

    return (
        <>
            {statusLabel && statusEnumName ? (
                <div className={`manageUsersByUserTable-generalContractor-status ${statusEnumName.toLowerCase()}`}>
                    {statusLabel}
                </div>
            ) : (
                <div className='manageUsersByUserTable-generalContractor-status-none'>No Status</div>
            )}
        </>
    );
};
